import React from "react";
import Card from "./card";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Featured = () => {
  return (
    <div className="bg-[#e6e8f0] px-5 pb-5">
      <div className="flex justify-between items-center ">
        <p className="my-4 font-rubik font-bold text-2xl">Featured Games</p>
        <ul className="flex font-rubik gap-5">
          <li className="font-bold text-primary text-xl">All</li>
          <li className="font-bold text-[#5f686f] text-xl">Xbox</li>
          <li className="font-bold text-[#5f686f] text-xl">Playstation</li>
          <li className="font-bold text-[#5f686f] text-xl">PC</li>
        </ul>
      </div>

      <Carousel responsive={responsive}>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
      </Carousel>
    </div>
  );
};

export default Featured;
